import type { IConfiguration } from '../../Data/ConfigurationData';

export const JD_POWER_API_KEY_MISSING_REASON =
  'This dealership needs a JD Power API key before JD Power can be used';

/**
 * Why the JD Power (car valuation) button is unavailable, or undefined when it should work.
 * The API key is the only JD Power transport; the server reports whether one exists as
 * `jdPowerApiKeyConfigured` (never the key). Fail-open: only an explicit false disables,
 * so a still-loading configuration or an older API never greys out a working button.
 */
export function getJdPowerDisabledReason(
  configuration: Pick<IConfiguration, 'jdPowerApiKeyConfigured'> | undefined,
): string | undefined {
  return configuration?.jdPowerApiKeyConfigured === false ? JD_POWER_API_KEY_MISSING_REASON : undefined;
}
